// @ts-check
const importAll = i => i.keys().forEach(i);

// @ts-ignore
const components = require.context('.', true, /\/index\.js$/);

importAll(components);



// WEBPACK FOOTER //
// ./src/components/index.js